/** Words of the local part of an email: "sylvio.degregorio@nivio.ai" -> ["sylvio", "degregorio"]. */
function emailWords(email: string): string[] {
  return (email.split('@')[0] ?? '').split(/[._-]+/).filter(Boolean);
}

const capitalize = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);

/** "sylvio.degregorio@nivio.ai" becomes "SD" (at most two letters, "?" when empty). */
export function initialsFromEmail(email: string): string {
  return (
    emailWords(email)
      .map((word) => word[0]?.toUpperCase() ?? '')
      .join('')
      .slice(0, 2) || '?'
  );
}

/** "sylvio.degregorio@nivio.ai" becomes "Sylvio". */
export function firstNameFromEmail(email: string | undefined): string | null {
  const first = email ? emailWords(email)[0] : undefined;
  return first ? capitalize(first) : null;
}

/** "sylvio.degregorio@nivio.ai" becomes "Sylvio Degregorio"; the email itself when no words. */
export function nameFromEmail(email: string): string {
  return emailWords(email).map(capitalize).join(' ') || email;
}

/** First and last initial of a name or email: "Sylvio De Gregorio" becomes "SG". */
export function initials(name: string): string {
  const parts = name
    .replace(/@.*$/, '')
    .split(/[\s._-]+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase();
}
